import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

const title = "Meeting Options";

// Clone the default theme and set primary color to #1777ab
const customTheme = {
  ...webLightTheme,
  colorBrandBackground: "#1777ab", // main primary bg
  colorBrandBackground2: "#1777ab",
  colorBrandBackgroundHover: "#16699a",
  colorBrandBackgroundPressed: "#12577e",
  colorBrandForeground1: "#1777ab",
  colorBrandForeground2: "#1777ab",
};

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={customTheme}>
      <App />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
